module.exports = __webpack_public_path__ + "tag-green.png?8b3ef473e42807ebbbc0f4dd4192049a";


//////////////////
// WEBPACK FOOTER
// ./dist/tag-green.png
// module id = 227
// module chunks = 0